import { useEffect } from 'react'
import { t } from '../i18n/translations.ts'

interface Props {
  onClose: () => void
}

/**
 * あそびかた（ヘルプ）モーダル。
 * - 背景クリック / ESC / ✕ ボタンで閉じる
 * - 中身は縦スクロール可能（iOS の pan-y 対応）
 */
export function HelpModal({ onClose }: Props) {
  // ESC キーで閉じる
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  // 背景スクロール抑止
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [])

  return (
    <div
      className="help-modal__overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="help-modal-title"
      onClick={onClose}
    >
      <div
        className="help-modal__dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="help-modal__header">
          <h2 id="help-modal-title" className="help-modal__title">
            {t('help')}
          </h2>
          <button
            type="button"
            className="help-modal__close"
            aria-label={t('closeAria')}
            onClick={onClose}
          >
            ×
          </button>
        </header>

        <div
          className="help-modal__body"
          style={{ touchAction: 'pan-y' }}
        >
          <section className="help-section">
            <h3 className="help-section__title">{t('helpGoalTitle')}</h3>
            <p className="help-section__text">
              {t('helpGoalText')}
            </p>
          </section>

          <section className="help-section">
            <h3 className="help-section__title">{t('helpWinTitle')}</h3>
            <ul className="help-section__list">
              <li>{t('helpWinFive')}</li>
              <li>{t('helpWinScore')}</li>
            </ul>
          </section>

          <section className="help-section">
            <h3 className="help-section__title">{t('helpScoreTitle')}</h3>
            <ul className="help-section__list">
              <li>{t('helpLineBonus')}</li>
              <li>{t('helpClusterBonus')}</li>
              <li>{t('helpKomi')}</li>
            </ul>
          </section>

          <section className="help-section">
            <h3 className="help-section__title">{t('helpControlsTitle')}</h3>
            <p className="help-section__text">
              {t('helpControlsText')}
            </p>
          </section>

          <section className="help-section">
            <h3 className="help-section__title">{t('helpTipsTitle')}</h3>
            <ul className="help-section__list">
              <li>{t('helpTipHell')}</li>
              <li>{t('helpTipCluster')}</li>
            </ul>
          </section>
        </div>

        <footer className="help-modal__footer">
          <button
            type="button"
            className="btn btn--primary"
            onClick={onClose}
          >
            {t('close')}
          </button>
        </footer>
      </div>
    </div>
  )
}
